import crmAPI from '../../routes/dashboard/crm/api/crm';

const state = {
  pipelines: [],
  selectedPipelineId: null,
  uiFlags: {
    isFetchingPipelines: false,
  },
};

const getters = {
  getPipelines: $state => $state.pipelines,
  getSelectedPipelineId: $state => $state.selectedPipelineId,
  getUiFlags: $state => $state.uiFlags,
};

const actions = {
  fetchPipelines: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetchingPipelines: true });
    try {
      const response = await crmAPI.getPipelines();
      commit('SET_PIPELINES', response.data || []);
    } catch (error) {
      console.error('Error fetching CRM pipelines in Vuex:', error);
    } finally {
      commit('SET_UI_FLAG', { isFetchingPipelines: false });
    }
  },
  setSelectedPipelineId: ({ commit }, id) => {
    commit('SET_SELECTED_PIPELINE_ID', id);
  },
};

const mutations = {
  SET_PIPELINES: ($state, pipelines) => {
    $state.pipelines = pipelines;
  },
  SET_SELECTED_PIPELINE_ID: ($state, id) => {
    $state.selectedPipelineId = id;
  },
  SET_UI_FLAG: ($state, flag) => {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
